<template>
    <div style="display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;">
        Wait until we are verifying you...
    </div>
</template>

<script>
import {
    mapMutations
} from 'vuex'
export default {
    methods: {
        ...mapMutations(['UserAccount', 'logIn']),
    },
    watch: {
        '$route.query': {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    let queryKey = JSON.parse(newVal.key);
                    let linkData = JSON.parse(queryKey.hasOwnProperty('OfferTest') ? queryKey.OfferTest : null)
                    setTimeout(() => {
                        localStorage.setItem("userToken", queryKey.token);
                        localStorage.setItem("account", JSON.stringify(queryKey.account))
                        localStorage.setItem("user", JSON.stringify(queryKey.user))
                        localStorage.setItem("credit", JSON.stringify(queryKey.credit))
                        this.UserAccount()
                        this.logIn()
                        if (linkData && linkData.link) {
                            this.$router.push(`/?url=${linkData.link}&country=${linkData.country}&device=${linkData.platform}&city=${linkData.city}&version=${linkData.os_version}&isp=${linkData.isp}&runTest=1`)
                        } else {
                            this.$router.push(`/`)
                        }
                        this.$root.$emit('LogChange')
                    }, "2000")
                }
            }
        }
    }
}
</script>
